export const cols = [{
	prop: 'name',
	label: '单位',
	width: '180',
	align: 'center',
	show: true
}, {
	prop: 'spec',
	label: '规格',
	width: '180',
	align: 'center',
	show: true
}, {
	prop: 'standardweight',
	label: '标准重量',
	width: '180',
	align: 'center',
	show: true
}, {
	prop: 'defaultprice',
	label: '商品统一单价（元）',
	width: '180',
	align: 'center',
	show: true
}]
